import React from 'react'
import { TestNavCircle } from './TestNavCircle'

interface ITestNavigationBar {
  step: number
}

const TestNavigationBar = ({step}:ITestNavigationBar) => {


  return (
    <div className='__test-nav' >
      <TestNavCircle pageNumber="1" isActive={step === 1 ? true : false} />
      <TestNavCircle pageNumber="2" isActive={step === 2 ? true : false} />
      <TestNavCircle pageNumber="3" isActive={step === 3 ? true : false} />
      <TestNavCircle pageNumber="4" isActive={step === 4 ? true : false} />
      <TestNavCircle pageNumber="5" isActive={step === 5 ? true : false} />
      <TestNavCircle pageNumber="6" isActive={step === 6 ? true : false} />
      <TestNavCircle pageNumber="7" isActive={step === 7 ? true : false} />
    </div> 
  )
}

export default TestNavigationBar